import { render, staticRenderFns } from "./BuyPop.vue?vue&type=template&id=49d7faee&"
import script from "./BuyPop.vue?vue&type=script&lang=js&"
export * from "./BuyPop.vue?vue&type=script&lang=js&"
import style0 from "./BuyPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports